let disableHandler: (() => Promise<void>) | null = null

export const registerPushRegistrationDisableHandler = (handler: (() => Promise<void>) | null): void => {
    disableHandler = handler
}

export const removePushDeviceOnLogout = (): void => {
    if (! disableHandler) {
        return
    }

    disableHandler().catch(error => console.error(error))
}
